import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-services10',
  templateUrl: './section-services10.component.html',
  styleUrls: ['./section-services10.component.css']
})
export class SectionServices10Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
